import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	IAssignmentHistoryLayerDetailStore,
	IPayloadGetAssignmentHistoryLayerListRequest,
	IPayloadGetAssignmentHistoryLayerListSuccess,
} from './assignment-history-layer.type';

const initialState = {
	fetching: false,
	assignmentHistoryLayerList: [] as IAssignmentHistoryLayerDetailStore[],
};

const assignmentHistoryLayerSlice = createSlice({
	initialState,
	name: 'assignmentHistoryLayer',
	reducers: {
		/**---- GET ASSIGNMENT_HISTORY_LAYER LIST START ---- */
		getAssignmentHistoryLayerListRequest: (
			state,
			action: PayloadAction<IPayloadGetAssignmentHistoryLayerListRequest>
		) => {
			state.fetching = true;
		},
		getAssignmentHistoryLayerListSuccess: (
			state,
			action: PayloadAction<IPayloadGetAssignmentHistoryLayerListSuccess>
		) => {
			const { content } = action.payload;
			state.fetching = false;
			state.assignmentHistoryLayerList = content;
		},
		getAssignmentHistoryLayerListFailure: (state) => {
			state.fetching = false;
		},
		/**---- GET ASSIGNMENT_HISTORY_LAYER LIST END ---- */
	},
});

export const AssignmentHistoryLayerSelectors = {
	selectFetching: (state: RootState) => state.assignmentHistoryLayer.fetching,
	selectList: (state: RootState) =>
		state.assignmentHistoryLayer.assignmentHistoryLayerList,
};

export const AssignmentHistoryLayerActions =
	assignmentHistoryLayerSlice.actions;
export const AssignmentHistoryLayerReducer =
	assignmentHistoryLayerSlice.reducer;
